import React from 'react';
import styles from './index.module.scss';

const CustomLink = props => {
  const { text, linkTo, linkProps = {}} = props;
  
  return (
    <a
      href={linkTo}
      className={styles['table-link']}
      {...linkProps}
    >
      {text}
    </a>
  );
};
export default CustomLink;